<form [formGroup]="form" *ngIf="field">
  <div class="form-field check-field">
    <span class="checkbox-icon">
      <input type="checkbox" formControlName="show" id="showValues" />
      <label class="inline-icon icon-editor-checkbox-light-unchecked" for="showValues"> Show labels </label>
    </span>
  </div>
</form>
